import { cn } from '@/utils/classname';
import { chip, Tooltip, TooltipContent, TooltipTrigger } from '@skand/ui';
import { forwardRef, ReactNode } from 'react';

export const ToolBarDropdownButton = forwardRef<
  HTMLDivElement,
  {
    analyticsEventObject?: string;
    icon: ReactNode;
    tooltip: string | ReactNode;
    onClick?: () => void;
    isActive?: true | 'dark' | false;
    isDisabled?: boolean;
  }
>(({ analyticsEventObject, icon, tooltip, onClick, isActive, isDisabled }, ref) => {
  return (
    <Tooltip>
      <div className="h-30px w-40px" ref={ref}>
        <TooltipTrigger asChild>
          <div
            aria-disabled={isDisabled}
            className={cn(
              'TooltipTriggerButton cursor-pointer justify-center items-center flex transition-colors',
              [
                'h-30px w-40px b-1 b-solid b-neutral-100 rounded-1 color-neutral-100',
                'group-[[data-state=open]]:bg-primary-400',
                'aria-disabled:opacity-50 aria-disabled:cursor-not-allowed',
                !isDisabled && isActive === false && 'hover:bg-neutral-400 bg-neutral-800/10',
                isActive === true && 'bg-primary-400',
                isActive === 'dark' && 'bg-primary-500',
              ],
            )}
            data-analytics-event-object={analyticsEventObject}
            onClick={isDisabled ? undefined : onClick}
          >
            {icon}
          </div>
        </TooltipTrigger>
      </div>

      <TooltipContent className="overflow-visible">
        {typeof tooltip === 'string' ? (
          <span className={cn(chip({ shadow: true }))}>{tooltip}</span>
        ) : (
          tooltip
        )}
      </TooltipContent>
    </Tooltip>
  );
});

ToolBarDropdownButton.displayName = 'ToolBarDropdownButton';
